import Cliser from 'cliser';
import Config from 'config';

export default class LoginModel extends Cliser.Model {

  properties() {
    return {
      token: window.localStorage.getItem("token") || null,
      email: null,
      error: null,
      processing: false,
      gtoken: null,
    }
  }

  static setToken(token) {
    this.token = token;
    this.emit();
  }

  static setGToken(token) {
    this.gtoken = token;
    this.emit();
  }

  static getGToken() {
    console.log("Config:",Config);
    return fetch(Config.servers.flowOneApi + '/lifecycle/gtoken', {
      method: 'get',
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': Config.apiKeys.flowOneApiKey
    }).then((resp) => {
      console.log("gtoken resp:", resp);
      //this.gtoken = resp.token;
      //this.emit();
      return resp.token;
    });
  }

  static login(email, password) {

    const loginParams = {
      username: email,
      password: password,
      type: 'client',
      system: true,
      //devices: 0,
      //tag: "livion/test-optiwater"
    };

    this.error = null;
    this.processing = true;

    // Post request
    return fetch(Config.servers.api + '/login', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(loginParams)
    })
      // Convert to JSON
      .then((response) => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(response.statusText);
      })
      // Login
      .then((json) => {
        this.email = json.username;
        this.token = json.token;
      })
      // Handle error
      .catch((error) => {
        this.email = null;
        this.token = null;
        this.error = error.message;
      })
      // End processing
      .then(() => {
        this.processing = false;
        this.emit();
      });
  }

}



// WEBPACK FOOTER //
// ./client/models/LoginModel.js